import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Button, Divider, Popover, Progress, Tooltip } from 'antd';
import { useLocation, useNavigate }from "react-router-dom"; 
import styles from './loginHead.module.scss'
import SwitchHomePageType from '../SwitchHomePageType';

function LoggedHead (props) {
    const location = useLocation();

    const showSwitchHomePageType = useMemo(() => { // 左上角logo显示品类
        return location.pathname != '/' && location.pathname != '/home/image_extraction' && location.pathname != '/home/homemain/personalCenter'
    }, [location.pathname])

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        props.onLogin()
    }

    return (
         <div className={styles.LoggedHead}>
            {
                showSwitchHomePageType ?
                <SwitchHomePageType /> : <i></i>
            }
            <div style={{display: 'flex'}}>
                <Button className='btn_r' type="primary" onClick={handleClick}><span>登录</span><Divider style={{backgroundColor: '#FFF'}} type="vertical" /><span>注册</span></Button>
            </div>
        </div>
       
    )
}

export default LoggedHead